module.exports = __webpack_public_path__ + "static/media/designer.54adb9ad.svg";